import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import _ from 'lodash';

import { useGuestCartDetail, useGuestStoreDetails } from 'api/guest_sdk';

import AirbnbResolutionCenterModal from 'components/Store/NewCheckout/AirbnbResolutionCenterModal';
import Layout from 'components/StoreLayout';
import BackToStore from 'components/Store/NewCheckout/BackToStore';
import PayNowButton from 'components/Store/NewCheckout/PayNowButton';
import OrderSummary from 'components/Store/NewCheckout/OrderSummary';
import OrderProduct from 'components/Store/NewCheckout/OrderProduct';
import StoreLayoutHeader from 'components/StoreLayout/Header';
import Footer from 'components/Layout/Footer';

import Stack from 'ui-kit/Stack';
import { Card, Spin } from 'ui-kit';
import './styles.scss';

const CartDetailsPage = () => {
  const params = useParams<{ storeId?: string; customerId?: string }>();
  const storeId = useMemo(() => Number(params.storeId), [params.storeId]);

  const [isOpenAirbnbModal, setIsOpenAirbnbModal] = useState(true);

  const {
    data: order,
    isLoading: isCartLoading,
    mutate: mutateGuestOrder,
  } = useGuestCartDetail({
    storeId,
  });

  useEffect(() => {
    if (order && !order.has_off_platform_products) {
      setIsOpenAirbnbModal(false);
    }
  }, [order]);

  const { data: storeData, isLoading: isStoreLoading } = useGuestStoreDetails({ storeId });

  const enterpriseInfo = useMemo(() => storeData?.enterprise_info, [storeData]);
  const isEnterprise = useMemo(() => {
    if (enterpriseInfo?.id) {
      return true;
    }
    return false;
  }, [enterpriseInfo]);
  const isLoading = useMemo(() => isCartLoading || isStoreLoading, [isCartLoading, isStoreLoading]);
  const companyName = useMemo(() => enterpriseInfo?.company_name, [enterpriseInfo]);
  const logo = useMemo(() => enterpriseInfo?.image, [enterpriseInfo]);

  const handleConfirmAirbnbModal = useCallback(() => {
    setIsOpenAirbnbModal(false);
    mutateGuestOrder();
  }, [mutateGuestOrder]);

  if (isLoading) {
    return null;
  }

  return (
    <>
      <AirbnbResolutionCenterModal
        orderId={order?.id}
        isOpen={isOpenAirbnbModal}
        initalIsPurchasableOffPlatform={order?.is_purchasable_off_platform}
        onUpdate={handleConfirmAirbnbModal}
      />
      <Spin spinning={isLoading}>
        <StoreLayoutHeader
          companyName={companyName}
          logo={logo}
          isEnterprise={isEnterprise}
          isLoading={isLoading}
        ></StoreLayoutHeader>
        <Layout.Content className="StoreCheckout_layout">
          <div className="StoreCheckout_content">
            <div style={{ marginBottom: 20 }}>
              <BackToStore storeId={storeId} />
            </div>
            {order && <OrderSummary order={order} />}
            <div style={{ marginTop: 20, marginBottom: 20 }}>
              <Card style={{ padding: '20px' }}>
                {order?.order_products?.length > 0 ? (
                  <Stack flexDirection="column" gap="8px">
                    {order?.order_products?.map((orderProduct) => (
                      <OrderProduct
                        key={orderProduct.id}
                        orderProduct={orderProduct}
                        currency={order.currency}
                        onAddItem={mutateGuestOrder}
                        onDeductItem={mutateGuestOrder}
                      />
                    ))}
                  </Stack>
                ) : (
                  <div>Nothing has been added to your cart yet!</div>
                )}
              </Card>
            </div>
          </div>
        </Layout.Content>
        <Footer isEnterprise={enterpriseInfo?.is_enabled} about={enterpriseInfo?.about} />
        <div className="StoreCheckout-fix-actions">
          <div className="StoreCheckout-fix-actions-content">
            <PayNowButton storeId={storeId} />
          </div>
        </div>
      </Spin>
    </>
  );
};

export default CartDetailsPage;
